import { useContext, useEffect, useState } from 'react';
import FormComp from './FormComp';
import FormContext from '../contexts/form/formContext';
import { AlertComp } from './Layouts/Alert';

const Home = () => {
  const { clearState, alert } = useContext(FormContext);

  const [alertMessage, setAlertMessage] = useState({
    alert: false,
    message: '',
    title: '',
  });

  useEffect(() => {
    if (alert !== '') {
      clearState();

      return setAlertMessage((prev) => ({
        ...prev,
        alert: true,
        title: 'Success',
        message: 'Passport(s) uploaded successfully',
      }));
    }
    //eslint-disable-next-line
  }, [alert]);

  return (
    <div>
      <h1 className="mt-2 mb-4 text-md md:text-3xl font-semibold title-color">
        NATIONAL DIGITAL LITERACY COMPETITION 2022
        <br />
        <br />
        <span className="text-blue-500">FINALIST PASSPORT UPLOAD</span>
      </h1>
      {alertMessage.alert && (
        <AlertComp
          alertMessage={alertMessage}
          setAlertMessage={setAlertMessage}
        />
      )}
      <FormComp />
    </div>
  );
};

export default Home;
